<template>
	<div class="relative bg-gray-50 md:bg-transparent">
		<v-scrollable inset-scrollbar>
			<div
				class="flex snap-x snap-proximity flex-nowrap space-x-md md:grid md:grid-cols-2 md:gap-xs md:space-x-0"
			>
				<v-scrollable-item
					v-for="(asset, index) in assets"
					:key="asset.id"
					class="flex w-screen shrink-0 snap-start items-center justify-center px-md md:w-auto md:bg-gray-50 md:py-md"
					:class="{
						'md:col-span-2': index === 0,
					}"
				>
					<!-- eslint-disable-next-line vuejs-accessibility/media-has-caption -->
					<video
						v-if="
							videoExtensions.includes(getFileExtension(asset.filename || ''))
						"
						controls
						class="w-full"
						muted
						autoplay
						loop
						playsinline
						:poster="asset.filename"
						loading="lazy"
					>
						<source :src="asset.filename" type="video/mp4" />
					</video>

					<nuxt-picture
						v-else
						:src="asset.filename"
						:alt="asset.alt"
						provider="storyblok"
						loading="lazy"
						class="w-full"
						:sizes="
							index === 0
								? 'xs:90vw sm:90vw md:336px lg:464px xl:592px 2xl:720px'
								: 'xs:90vw sm:90vw md:140px lg:204px xl:268px 2xl:332px'
						"
					/>
				</v-scrollable-item>
			</div>
		</v-scrollable>
	</div>
</template>

<script setup lang="ts">
import type {BlokAsset} from "@pkg/shared/types";

defineProps<{
	assets: BlokAsset[];
}>();

// List of video file extensions to check against. Can be extended as needed.
const videoExtensions = ["mp4", "webm", "ogg", "mov"];

// Function to get the file extension from a filename.
function getFileExtension(filename: string): string {
	const [, extension] = /^.+\.([^.]+)$/.exec(filename) ?? [];

	return extension ?? "";
}
</script>
